<div class="layoutBlock">
    <div class="columnHalf">
        <p-panel
            header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bahncard.overview' | hisUi}}"
            [toggleable]="false">
            <div class="layoutBlock">
                <div class="columnFull">
                    <div class="listviewBadgeLeft">
                        <div class="circleIconContainer">
                            <div class="circle-icon">
                                <div><img hisImage="BAHNCARD" class="inlineicon"
                                        title="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.icon.bahncard' | hisUi}}">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="listviewSideRight">
                        <h2>{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bahncard.bahncardFirst'
                            | hisUi}}
                        </h2>
                        <ul class="listSimple">
                            <li>
                                <div *ngIf="true" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bahncard.identifier'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{bahncard.bahncardSelected?.defaulttext}}</div>
                                </div>
                            </li>
                            <li>
                                <div *ngIf="true" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bahncard.discount'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{bahncard.discountFirstBc}}</div>
                                </div>
                            </li>
                            <li>
                                <div *ngIf="true" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bahncard.validFrom'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{bahncard.validFromDateFirstBc | hisDate}}</div>
                                </div>
                            </li>
                            <li>
                                <div *ngIf="true" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bahncard.validTo'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{bahncard.validToDateFirstBc | hisDate}}</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="columnFull">
                    <div class="listviewBadgeLeft">
                        <div class="circleIconContainer">
                            <div class="circle-icon">
                                <div><img hisImage="BAHNCARD" class="inlineicon"
                                        title="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.icon.bahncard">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="listviewSideRight">
                        <h2>{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bahncard.bahncardSecond'
                            | hisUi}}
                        </h2>
                        <ul class="listSimple">
                            <li>
                                <div *ngIf="true" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bahncard.identifier'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn"></div>
                                </div>
                            </li>
                            <li>
                                <div *ngIf="true" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bahncard.discount'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{bahncard.discountSecondBc}}</div>
                                </div>
                            </li>
                            <li>
                                <div *ngIf="true" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bahncard.validFrom'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{bahncard.validFromDateSecondBc | hisDate}}</div>
                                </div>
                            </li>
                            <li>
                                <div *ngIf="true" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bahncard.validTo'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{bahncard.validToDateSecondBc | hisDate}}</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </p-panel>
    </div>

    <div class="columnHalf">
        <p-panel
            header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bahncard.changes' | hisUi}}"
            [toggleable]="false">

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bahncard.applyChanges"
                    [(ngModel)]="bahncard.changeBahncard" (ngModelChange)="resetBahncardChanges()" type="checkbox" />
            </his-plam>

            <his-plam>
                <p-autoComplete #selectedBahncardDropdown #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bahncard.bahncardSelected"
                    styleClass="autocompleteWidth100" field="text" [disabled]="bahncard.changeBahncard !== true"
                    [(ngModel)]="tempBahncardSelected" (ngModelChange)="bahncardSelected()"
                    hisEagerDataSource="api/v1/rm/erp/travelmanagement/values/erpbahncard" [forceSelection]="true">
                </p-autoComplete>
            </his-plam>

            <his-plam>
                <p-calendar #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bahncard.validFrom"
                    [disabled]="bahncard.changeBahncard !== true" [(ngModel)]="bahncard.changeFromDate"
                    [showTime]="false" styleClass="calendarWidth100" [monthNavigator]="true" [yearNavigator]="true">
                </p-calendar>
            </his-plam>

            <his-plam>
                <p-calendar #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bahncard.validTo"
                    [disabled]="bahncard.changeBahncard !== true" [(ngModel)]="bahncard.changeToDate" [showTime]="false"
                    styleClass="calendarWidth100" [monthNavigator]="true" [yearNavigator]="true">
                </p-calendar>
            </his-plam>

            <button (click)="saveBahncardChanges()"><span>{{ 'common.apply' | hisUi }}</span></button>
            <button><span>{{ 'common.reset' | hisUi }}</span></button>

        </p-panel>
    </div>
</div>